(function () {
  'use strict';

  var FAV_KEY = 'zahav_fav_';
  var FAV_DATA_KEY = 'zahav_favdata_';
  var PENDING_KEY = 'zahav_pending_fav';
  var PENDING_DATA_KEY = 'zahav_pending_favdata';
  var VERCEL_URL = 'https://zahav-chatbot.vercel.app';

  var pushTimer = null;

  function isFav(pid) {
    return localStorage.getItem(FAV_KEY + pid) === '1';
  }

  function getProductData(el) {
    return {
      handle: el.dataset.handle || '',
      title: el.dataset.title || '',
      price: el.dataset.price || '',
      image: el.dataset.image || ''
    };
  }

  function saveProductData(pid, el) {
    var d = getProductData(el);
    if (d.handle) {
      try { localStorage.setItem(FAV_DATA_KEY + pid, JSON.stringify(d)); } catch (e) {}
    }
  }

  function toggleFav(pid, el) {
    var now = !isFav(pid);
    try { localStorage.setItem(FAV_KEY + pid, now ? '1' : '0'); } catch (e) {}
    if (now && el) saveProductData(pid, el);
    return now;
  }

  function setState(btn, active) {
    btn.classList.toggle('is-favorited', active);
    btn.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
  }

  function getPid(el) {
    var pid = el.dataset && el.dataset.pid;
    if (pid) return pid;
    var row = el.closest && el.closest('.zahav-atc-row');
    if (row && row.dataset.productId) return row.dataset.productId;
    var form = el.closest && el.closest('product-form-component');
    if (form && form.dataset.productId) return form.dataset.productId;
    return '';
  }

  function getCid() {
    return window.zahavCustomerId || '';
  }

  // Read all current local favorites as an array
  function getLocalFavs() {
    var favs = [];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && key.indexOf(FAV_KEY) === 0 && localStorage.getItem(key) === '1') {
          var pid = key.slice(FAV_KEY.length);
          var raw = localStorage.getItem(FAV_DATA_KEY + pid);
          var data = {};
          try { data = raw ? JSON.parse(raw) : {}; } catch (e) {}
          favs.push({ pid: pid, handle: data.handle || '', title: data.title || '', price: data.price || '', image: data.image || '' });
        }
      }
    } catch (e) {}
    return favs;
  }

  // Write a favorites array into localStorage
  function writeLocalFavs(favs) {
    favs.forEach(function (f) {
      try {
        localStorage.setItem(FAV_KEY + f.pid, '1');
        if (f.handle) {
          localStorage.setItem(FAV_DATA_KEY + f.pid, JSON.stringify({
            handle: f.handle, title: f.title, price: f.price, image: f.image
          }));
        }
      } catch (e) {}
    });
  }

  // Push current favorites to Vercel KV (debounced 800ms)
  function schedulePush() {
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      var cid = getCid();
      if (!cid) return;
      var favs = getLocalFavs();
      fetch(VERCEL_URL + '/api/favorites-set', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cid: cid, favorites: favs })
      }).catch(function () {});
    }, 800);
  }

  // On page load (logged in): fetch server favorites and merge with local
  function syncWithServer() {
    var cid = getCid();
    if (!cid) return;

    fetch(VERCEL_URL + '/api/favorites-get?cid=' + encodeURIComponent(cid))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var serverFavs = data.favorites || [];
        if (!serverFavs.length) {
          // No server data yet — push local favorites up so they're saved
          var local = getLocalFavs();
          if (local.length) schedulePush();
          return;
        }

        // Merge: start with local, overlay server entries
        var merged = {};
        getLocalFavs().forEach(function (f) { merged[f.pid] = f; });
        serverFavs.forEach(function (f) { merged[f.pid] = f; });

        var hadLocalExtras = false;
        getLocalFavs().forEach(function (f) {
          var onServer = false;
          serverFavs.forEach(function (s) { if (s.pid === f.pid) onServer = true; });
          if (!onServer) hadLocalExtras = true;
        });

        // Write merged set to localStorage
        writeLocalFavs(Object.keys(merged).map(function (pid) { return merged[pid]; }));

        // Update any heart buttons already on the page
        document.querySelectorAll('button.zahav-fav-heart').forEach(function (btn) {
          var pid = getPid(btn);
          if (pid && merged[pid]) setState(btn, true);
        });

        // If local had items the server didn't, push the merged set up
        if (hadLocalExtras) schedulePush();
      })
      .catch(function () {}); // silently fail — localStorage still works
  }

  function attachHeart(btn) {
    if (btn._zahavFavInit) return;
    btn._zahavFavInit = true;

    var pid = getPid(btn);
    if (pid) setState(btn, isFav(pid));

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var p = getPid(btn);
      if (!p) return;
      setState(btn, toggleFav(p, btn));
      schedulePush();
    });
  }

  function applyPending() {
    var pending = localStorage.getItem(PENDING_KEY);
    if (!pending) return;
    localStorage.removeItem(PENDING_KEY);
    try { localStorage.setItem(FAV_KEY + pending, '1'); } catch (e) {}
    var pendingData = localStorage.getItem(PENDING_DATA_KEY);
    if (pendingData) {
      try { localStorage.setItem(FAV_DATA_KEY + pending, pendingData); } catch (e) {}
      localStorage.removeItem(PENDING_DATA_KEY);
    }
    document.querySelectorAll('button.zahav-fav-heart').forEach(function (btn) {
      if (getPid(btn) === pending) setState(btn, true);
    });
    schedulePush();
  }

  function initAll() {
    document.querySelectorAll('button.zahav-fav-heart').forEach(attachHeart);
    applyPending();
    syncWithServer();
  }

  // Save pending fav + product data before login/signup redirect
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.zahav-fav-heart');
    if (!a) return;
    var pid = getPid(a) || '';
    if (!pid) return;
    try {
      localStorage.setItem(PENDING_KEY, pid);
      var d = getProductData(a);
      if (d.handle) localStorage.setItem(PENDING_DATA_KEY, JSON.stringify(d));
    } catch (e) {}
  });

  // Attach to buttons as they enter the DOM (panel injection, variant re-renders)
  new MutationObserver(function (mutations) {
    var pending = localStorage.getItem(PENDING_KEY);
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var btns = [];
        if (node.tagName === 'BUTTON' && node.classList.contains('zahav-fav-heart')) {
          btns.push(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('button.zahav-fav-heart').forEach(function (b) { btns.push(b); });
        }
        btns.forEach(function (btn) {
          attachHeart(btn);
          if (pending && getPid(btn) === pending) {
            localStorage.removeItem(PENDING_KEY);
            try { localStorage.setItem(FAV_KEY + pending, '1'); } catch (e) {}
            saveProductData(pending, btn);
            var pd = localStorage.getItem(PENDING_DATA_KEY);
            if (pd) { try { localStorage.setItem(FAV_DATA_KEY + pending, pd); } catch (e) {} localStorage.removeItem(PENDING_DATA_KEY); }
            setState(btn, true);
            schedulePush();
            pending = null;
          }
        });
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Re-init after Shopify variant updates
  document.addEventListener('variant:update', function () {
    setTimeout(initAll, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Public API
  window.zahavFav = {
    getAll: getLocalFavs,
    remove: function (pid) {
      try { localStorage.setItem(FAV_KEY + pid, '0'); } catch (e) {}
      document.querySelectorAll('button.zahav-fav-heart').forEach(function (btn) {
        if (getPid(btn) === String(pid)) setState(btn, false);
      });
      schedulePush();
    }
  };
}());
